var map = {
	"./01.jpg": 181,
	"./02.jpg": 182,
	"./03.jpg": 183,
	"./banner_img.png": 184,
	"./design1.png": 185,
	"./design2.png": 186,
	"./featured_bg_shape.png": 411,
	"./featured_img1.png": 187,
	"./icon1.png": 412,
	"./icon2.png": 413,
	"./icon3.png": 414,
	"./icon_shape.png": 188,
	"./php.jpg": 189,
	"./shap_tecture.png": 415
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 936;